// extracted by mini-css-extract-plugin
export default {"buttonContainer":"DashboardAddButton_buttonContainer__Wejf4"};